var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BoxContent",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"boxOne"},[_c('svg-btn',{staticClass:"icon",attrs:{"icon-class":"icon-short-no"}}),_c('span',{staticClass:"font1"},[_vm._v("未找到短链页面，请检查短链是否正确")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }